import { render, staticRenderFns } from "./TenderMembersModal.vue?vue&type=template&id=0b59098c&"
import script from "./TenderMembersModal.vue?vue&type=script&lang=js&"
export * from "./TenderMembersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports